export default __webpack_public_path__ + "assets/timor-leste-flag.png";